import { render, staticRenderFns } from "./ModalResponderEsclarecimentoImpugnacao.vue?vue&type=template&id=0d105d28"
import script from "./ModalResponderEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
export * from "./ModalResponderEsclarecimentoImpugnacao.vue?vue&type=script&lang=js"
import style0 from "./ModalResponderEsclarecimentoImpugnacao.vue?vue&type=style&index=0&id=0d105d28&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports